import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { commonErrorMessages } from '../../messages';
import { GlobalActions } from '../../model';
import { News } from '../../model/news/news';
import {
  downloadNewsList,
  newsActions,
  NewsState,
} from '../../store/features/news';
import { useAppDispatch, useAppSelector } from '../redux';

export interface NewsPageLogic {
  news?: News[];
  isLoadingNews: boolean;
}

export const useNewsPageLogic = (actions: GlobalActions): NewsPageLogic => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const { showToast, closeToast } = actions;

  const token: string = useAppSelector((state) => state.data?.user?.token);

  const {
    news,
    newsRequestStatus,
    newsError: newsDownloadError,
  } = useAppSelector((state) => state.features.news as NewsState);

  useEffect(() => {
    if (token) {
      dispatch(downloadNewsList());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (newsDownloadError) {
      showToast({
        close: closeToast,
        title: formatMessage(commonErrorMessages.errorTitleDefault),
        description: formatMessage(commonErrorMessages.errorDescriptionDefault),
        type: 'error',
      });
      dispatch(newsActions.clearError());
    }
  }, [newsDownloadError, showToast, formatMessage, closeToast, dispatch]);

  return {
    isLoadingNews: newsRequestStatus === 'loading',
    news,
  };
};
